// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__3JNoS","hider":"Header_hider__pSZUC"};